import { UnitSearchParams } from "common/api/citajteo/dl_unit/citajteo_unit";
import { stringToBoolean } from "common/util/boolean/boolean_common";
import {
  UNIT_SEARCH_OPTIONS,
  UnitSearchOptions,
} from "constant/dl_unit/dl_unit.constant";
import { SEARCH_NAMES } from "constant/search/search";
import { useSearchParams, useParams } from "react-router-dom";

export function useUnitSearchOptionsFromUrl(): UnitSearchParams {
  const [searchParams] = useSearchParams();
  const params = useParams(); // This gets path parameters

  const result: UnitSearchParams = {};

  UNIT_SEARCH_OPTIONS.forEach((option: UnitSearchOptions) => {
    const queryValue = searchParams.get(option);
    if (queryValue !== null) {
      result[option] = queryValue;
    }
  });

  if ("slug" in params) {
    result[SEARCH_NAMES.GROUP_SLUG] = params.slug;
  }

  if (SEARCH_NAMES.U_TYPE in params) {
    result[SEARCH_NAMES.U_TYPE] = params[SEARCH_NAMES.U_TYPE]?.toUpperCase();
  }

  if (SEARCH_NAMES.AI_SEARCH in result) {
    result[SEARCH_NAMES.AI_SEARCH] = stringToBoolean(
      result[SEARCH_NAMES.AI_SEARCH] as string,
    );
  }

  return result;
}
